module.exports = __webpack_public_path__ + "static/media/1.3469211c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/gomel/1.JPG
// module id = 219
// module chunks = 0